module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "stripe"
  }, [_c('div', {
    staticClass: "img-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.fullImgPath('portrait.png'),
      "alt": "Portrait"
    }
  })]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stripe-intro"
  }, [_c('main', [_c('p', [_vm._v("\n\t\t\t\t\ttrilingual nerd fluent in human, musical, and computer languages,\n\t\t\t\t\tand passionate about becoming a better communicator in all three.\n\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\tbringing interdisciplinary perspectives and creativity to code since Hello world in 2015\n\t\t\t\t")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05abf83b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/Intro.vue
// module id = 111
// module chunks = 1